import { Select, styled } from "@mui/material";

export const StyledSelect = styled(Select)`
    background-color: ${props => props.theme.palette.bottomColor.main};
    border-radius: 10px;
`